<template>
  <div>
    <div>
      <!-- option -->
      <template v-for="(category, index) in options">
        <v-card :key="index" class="mb-2">
          <v-card-text>
            <v-layout>
              <v-flex
                class="form-control"
                :class="{ 'has-error': errors.has('category_' + index) }"
              >
                <input
                  :name="'category_' + index"
                  :data-vv-name="'category_' + index"
                  :data-vv-as="$t('option')"
                  type="text"
                  class="form-control"
                  v-validate="`required`"
                  v-model="category.name"
                  :placeholder="$t('option') + ' ' + $t('EX.Size, Color, Weight')"
                  @blur="$set(category, 'name', noSpaceAndSpecial($event))"
                />
                <span class="text-error caption" v-show="errors.has('category_' + index)">{{
                  errors.first('category_' + index)
                }}</span>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text class="pt-0">
            <div class="pa-2 grey lighten-4" style="border-radius: 5px" v-if="category.option">
              <template v-for="(option, oindex) in category.option">
                <v-layout wrap :key="oindex">
                  <v-flex xs4 sm2 class="py-2 px-2">
                    {{ $t('option') }}
                  </v-flex>
                  <v-flex
                    xs8
                    sm10
                    class="form-control"
                    :class="{ 'has-error': errors.has('option_' + index + '_' + oindex) }"
                  >
                    <v-layout wrap>
                      <v-flex xs12 sm8>
                        <input
                          :name="'option_' + index + '_' + oindex"
                          :data-vv-name="'option_' + index + '_' + oindex"
                          :data-vv-as="$t('option')"
                          type="text"
                          class="form-control"
                          :placeholder="$t('option') + ' ' + $t('EX.S, M, L, Red, Green')"
                          v-validate="`required`"
                          v-model="category.option[oindex]"
                          @blur="$set(category.option, oindex, noSpaceAndSpecial($event))"
                        />
                        <span
                          class="text-error caption"
                          v-show="errors.has('option_' + index + '_' + oindex)"
                          >{{ errors.first('option_' + index + '_' + oindex) }}</span
                        >
                      </v-flex>
                      <v-flex xs12 sm4>
                        <!-- <v-btn fab small flat class="ma-1">
                          <span class="fas fa-angle-up"></span>
                        </v-btn>
                        <v-btn fab small flat class="ma-1">
                          <span class="fas fa-angle-down"></span>
                        </v-btn> -->
                        <v-btn
                          fab
                          small
                          flat
                          class="ma-1"
                          :disabled="category.option.length <= 1"
                          @click="deleteOption(index, oindex)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- <product-stock-option
                  :key="oindex"
                  :option="option"
                  :delete-disabled="category.option.length <= 1"
                  @deleteOption=""
                ></product-stock-option> -->
              </template>

              <div class="btn-add text-xs-center my-2" @click="addOption(index)" v-if="limitOption">
                <v-icon class="mr-2">add</v-icon>{{ $t('Add') }} {{ $t('option') }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>

      <div
        class="btn-add text-xs-center mb-2 mt-4"
        @click="addCategory(1)"
        v-if="options.length < 2"
      >
        <v-icon class="mr-2">add</v-icon>Add Option
      </div>
    </div>
  </div>
</template>

<script>
import ProductStockOption from './ProductStockOption'
export default {
  inject: ['$validator'],
  props: ['value', 'totalOptions'],
  data() {
    return {
      options: [
        {
          level: 0,
          name: null,
          option: [''],
        },
      ],
    }
  },
  components: {
    ProductStockOption,
  },
  computed: {
    limitOption() {
      if (
        [
          '148831989096546',
          '1229692217050821',
          '135565533158593',
          '488563718210335',
          '799590883441878',
        ].includes(this.$store.state.selectedBot.pageid)
      ) {
        return true
      } else {
        return this.totalOptions <= 15
      }
    },
  },
  mounted() {
    var option = {
      level: 0,
      name: null,
      option: [''],
    }
    option.name = 'ตัวเลือก'
    try {
      this.options = this.value
      if (!this.options || (this.options && this.options.length == 0)) {
        this.options = []
        this.options.push(option)
        // this.$emit('addCategory', 0)
        this.$emit('input', this.options)
      }
    } catch (error) {
      this.options = []
      this.options.push(option)
      // this.$emit('addCategory', 0)
      this.$emit('input', this.options)
    }
  },
  methods: {
    defaultOption() {
      return {
        level: 0,
        name: null,
        option: [''],
      }
    },
    addOption(index) {
      this.options[index].option.push('')
      this.$emit('addOption', index)
    },
    deleteOption(index, oindex) {
      this.options[index].option.splice(oindex, 1)
      this.$emit('deleteOption', { sindex: index, oindex: oindex })
    },
    addCategory(index) {
      var option = {
        level: 0,
        name: null,
        option: [''],
      }
      option.level = 1
      this.options.push(option)
      this.$emit('addCategory', index)
    },
    deleteCategory(index) {
      this.options.splice(index, 1)
      this.$emit('deleteCategory', index)
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductStockCategory.vue